import CalculatorForm from '@Components/Shared/FinancialCalculator/CalculatorForm';
import Modal from '@Components/Shared/Modals/Modal';
import translator from '@Components/Utilities/Translator';

const CalculatorModal = (props) => {

    return (
        <Modal containerClassName='calculator-modal' onEscapeKeyClose={props.toggleCalculator}>
            <Modal.Header onClose={props.toggleCalculator}>
                <Modal.Title>
                    <>
                        {translator.translate('sandhills.tradepubwebsite.mvc.financialcalculator')}
                    </>
                    </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p id='description-label' className='hidden'>Calculate Costs.</p>
                <CalculatorForm {...props} HideCurrencySelector={true} />
            </Modal.Body>
        </Modal>
    );
}

export default CalculatorModal;